import { useEffect, useState } from "react";
import clsx from "clsx";
import t from "../locales";

const MINIMIZE_ICON = {
  viewBox: "0 0 16 16",
  path: "M3.33301 8.66659V7.33325H12.6663V8.66659H3.33301Z",
};

const MAXIMIZE_ICON = {
  viewBox: "0 0 15.8166 15.8166",
  path: "M8.36268 13.888V8.6158H13.6349V7.29775H8.36268V2.02555H7.04463V7.29775H1.77242V8.6158H7.04463V13.888H8.36268Z",
};

export default function Embed({ url, label, color }) {
  const [isMaximized, setIsMaximized] = useState(true);

  useEffect(() => {
    if (!isMaximized) return;

    function handleKeyDown(event) {
      if (event.key !== "Escape") return;
      if (event.target.closest("dialog[open]")) return;

      setIsMaximized(false);
    }

    document.addEventListener("keydown", handleKeyDown);

    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isMaximized]);

  const icon = isMaximized ? MINIMIZE_ICON : MAXIMIZE_ICON;

  return (
    <div
      className={clsx(
        "embed",
        isMaximized ? "embed--maximized" : "embed--minimized",
      )}
      style={{ "--embed-color": color }}
      data-testid="embed"
    >
      <div className="embed__frame">
        <iframe
          className="embed__iframe"
          src={url}
          title={t("embed.title")}
          // Below we make use of native mobile & VR features without any cost
          allow="accelerometer; gyroscope; magnetometer; xr-spatial-tracking"
        />
        <p className="embed__badge" hidden={!isMaximized}>
          {label}
        </p>
        <button
          className="embed__toggle"
          type="button"
          onClick={() => setIsMaximized((current) => !current)}
        >
          <svg
            className="embed__icon"
            viewBox={icon.viewBox}
            fill="currentColor"
            aria-hidden="true"
          >
            <path d={icon.path} />
          </svg>
          {t(`embed.${isMaximized ? "minimize" : "maximize"}`)}
        </button>
      </div>
    </div>
  );
}
